/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import type { ComponentProps, ReactElement } from 'react';
import { cssMap } from '@compiled/react';

import { jsx } from '@atlaskit/css';
import { token } from '@atlaskit/tokens';
import type { MediaInline as OriginalMediaInline } from '@atlaskit/renderer/nodes';

import type { LightNodeProps } from '../LightNodeObserver.ts';

const styles = cssMap({
	placeholder: {
		display: 'inline-block',
		verticalAlign: 'middle',
		backgroundColor: token('elevation.surface.sunken'),
		borderRadius: token('radius.small'),
		maxWidth: '100%',
	},
	file: { width: '120px', height: '24px' },
});

/** Reserve inline geometry without starting media providers or file subscriptions. */
export const MediaInline = ({
	id,
	collection,
	type,
	alt,
	width,
	height,
	lightNodeRef,
}: ComponentProps<typeof OriginalMediaInline> & LightNodeProps): ReactElement => (
	<span
		ref={lightNodeRef}
		data-node-type="mediaInline"
		data-id={id}
		data-collection={collection}
		css={[styles.placeholder, type !== 'image' && styles.file]}
		aria-label={alt || undefined}
		role={alt ? 'img' : undefined}
		// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Inline image dimensions come from ADF.
		style={type === 'image' ? { width: width || 16, height: height || 16 } : undefined}
	/>
);
